// extracted by mini-css-extract-plugin
export var page = "about-module--page--1d1V6";
export var back = "about-module--back--29vHm";
export var link = "about-module--link--14gCo";